import React, { Component } from 'react'
import classNames from 'classnames'

class Dropdown extends Component {
  constructor(props) {
    super(props)
    this.state = {
      toggled: false
    }

    this.toggleDropdown = this.toggleDropdown.bind(this)
    this.setWrapperRef = this.setWrapperRef.bind(this)
    this.handleClickOutside = this.handleClickOutside.bind(this)
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside)
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside)
  }

  setWrapperRef(node) {
    this.wrapperRef = node
  }

  handleClickOutside(event) {
    if (
      this.wrapperRef &&
      !this.wrapperRef.contains(event.target) &&
      !event.target.classList.contains('pac-item')
    ) {
      this.setState({ toggled: false })
    }
  }

  toggleDropdown() {
    const isSelected = !this.state.toggled
    this.setState({
      toggled: isSelected
    })
  }

  render() {
    const { borderless } = this.props
    const selectClassNames = classNames(
      'input-select form-control',
      this.props.selectClassName,
      {
        borderless,
        selected: this.state.toggled && !borderless,
        refined: this.props.refined
      }
    )

    return (
      <div
        className={classNames('dropdown', this.props.className)}
        ref={this.setWrapperRef}>
        <div
          className={selectClassNames}
          id={this.props.id || ''}
          onClick={this.toggleDropdown}>
          {this.props.title}
        </div>

        <div
          className={`dropdown-menu ${this.state.toggled ? 'toggled' : ''}`}
          onClick={this.toggleDropdown}>
          {this.props.children}
        </div>
      </div>
    )
  }
}

export default Dropdown
